import { defineMessages } from 'react-intl';

export default defineMessages({
    mandatoryTitle: {
        id: `Welcome {name}`,
        defaultMessage: `Welcome {name}`
    },
    mandatorySubmit: {
        id: 'Continue',
        defaultMessage: 'Continue'
    },
    amount: {
        id: 'How much would you like to borrow?',
        defaultMessage: 'How much would you like to borrow?'
    },
    maxAmountError: {
        id: '_.error.max_amount',
        defaultMessage: 'You can borrow a maximum of up to {amount}'
    },
    minAmountError: {
        id: '_.error.min_amount',
        defaultMessage: 'You can borrow a minimum of {amount}'
    },
    clientOrder: {
        id: '_.loan_request.client_order',
        defaultMessage: 'for financing a client order'
    },
    bill: {
        id: '_.loan_request.bill',
        defaultMessage: 'to pay a due bill'
    },
    taxBill: {
        id: '_.loan_request.tax_bill',
        defaultMessage: 'to pay a tax bill'
    },
    financingClientOrder: {
        id: '_.loan_request.financing_client_order',
        defaultMessage: 'for cash flow'
    }
});
